import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import { isEmpty } from 'lodash';

import CampusSitesTable from './CampusSitesTable';

import ActionBar from '../../components/ActionBar';

import * as ArchitectActions from '../../actions/architectActions';

import classes from './TableAndSearch.module.css';

const CampusSitesTableAndSearch = ({
    campusSites,
    fetchCampusSites,
    handleSort,
    order,
    orderBy,
    selectedNode,
    selectedClient,
    ...props
}) => {

    useEffect(() => {
        fetchCampusSites(selectedClient.id, selectedNode.id);
    }, []);

    const handleSearch = searchFilter => {
        if (isEmpty(searchFilter)) {
            fetchCampusSites(selectedClient.id, selectedNode.id);
        } else {
            fetchCampusSites(selectedClient.id, selectedNode.id, { searchFilter });
        }
    };

    return (
        <React.Fragment>
            <ActionBar
                onSearch={handleSearch}
            />
            <div className={classes.scrollContainer}>
                <CampusSitesTable
                    campusSites={campusSites}
                    order={order}
                    orderBy={orderBy}
                    onSort={property => handleSort(props, property)}
                />
            </div>
        </React.Fragment>
    );
};

const mapDispatchToProps = {
    ...ArchitectActions
};

export default connect(null, mapDispatchToProps)(CampusSitesTableAndSearch);
